import { FAQsection } from "../components/info";

export const WaitingPage = () => {
    return (
        <main className={`relative h-screen w-screen overflow-x-hidden text-gray-100/80 lowercase antialiased font-inter bg-[#101010]`}>
            <section>
            <div className="h-screen w-full flex items-center justify-center px-8 md:px-16">
                <div className="flex flex-col text-center items-center">
                    <h3 className="text-pretty mb-4 text-4xl leading-tight font-semibold tracking-tighter lg:text-6xl">
                        project unfinished.
                    </h3>
                    <p className="text-pretty mb-4 text-base line-clamp-6 text-white/70 font-light font-nunito max-w-3xl">
                    Got a habit of starting strong but finishing weak? (tee hee) From coding projects to comic books, revive, restart, or collaborate on unfinished projects. For more info, click 
                    <a href="#form-content"
                        onClick={(e) => {
                            e.preventDefault();
                            document.getElementById('faq').scrollIntoView({ behavior: 'smooth' });
                            
                        }}> <span className="underline decoration-1 underline-offset-4">here.</span></a>
                    </p>
                    <div className="flex flex-col space-x-0 space-y-4 items-center md:flex-row md:space-x-4 md:space-y-0 md:justify-center">
                    {/* <button className="w-fit px-4 py-2 bg-white/10 text-white/70 rounded-lg font-nunito font-light">
                        <p className="text-base">start a solo project</p>
                    </button> */}
                    <button className="w-fit px-4 py-2 bg-white/10 text-white/70 rounded-lg font-nunito font-light"
                    onClick={() => document.getElementById('form-content').scrollIntoView({ behavior: 'smooth' })}>
                        <p className="text-base">explore unfinished projects</p>
                    </button>
                    </div>
                </div>
            </div>
            </section>
            <section id="faq">
            <div className="h-screen w-full flex items-center justify-center px-8 md:px-16">
                <FAQsection/>
            </div>
            </section>
            <section id="form-content">
            <div class="w-full h-full">
            <iframe src="https://app.youform.com/forms/u8en9eau" loading="lazy" class="w-full h-svh border-0" marginheight="0" marginwidth="0"></iframe>
            </div>
            </section>
        </main>
    );
}